AppView.$inject = [];
function AppView() {
    return {
        template: require('./views/main.html'),
        controller: function () {
        },
        link: function (scope, elem, attrs, ctrl) {
        }
    };
}
angular.module('rinca.core.main.view', [])
    .directive('appView', AppView);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/main/view.ts
// module id = 286
// module chunks = 0